import { ISubclientServiceMock } from "./subclient.types";

export const mockSubclientService = (): ISubclientServiceMock => ({
  getSubclients: jest.fn(),
  getSubclientDetail: jest.fn(),
  saveUpdateSubclient: jest.fn(),
  updateStatusSubclient: jest.fn(),
  postGenerateSubclientsReport: jest.fn(),
  syncSubclient: jest.fn(),
});
